import { Theme } from "./symbols";

export const whiteTheme: Theme = {
    name: 'white',
    properties: {
      '--background': '#fff',
      '--on-background': '#0F0F0F',
      '--primary': '#389BFF',
      '--on-primary': '#fff',
      '--secondary': '#B2B4B7',
      '--on-secondary': '#fff',
      '--surface': '#fff',
      '--on-surface': '#0F0F0F',
      '--error': '#EB5945',
      '--on-error': '#fff',
      '--warning': '#F6BB42',
      '--on-warning': '#fff',
      '--color': '#003087',
      '--button-color': '#001E61'
    },
    settings: {
      roundedButtons: false
    }
  };
